import { gql } from 'apollo-boost';

export const CHAT_REPORT_FIELDS = gql`
  fragment ChatReportFields on ChatReportRecord {
    _id reporterId roomId reason content images status createdAt timeEstimated
    reviewedAt reviewedBy reviewNote roomMissing
    participants { uid nickname avatarUrl role missing isAnom }
  }
`;
export const GET_CHAT_REPORTS = gql`
  query ChatReports($page: Int, $status: String, $reporterId: ID, $roomId: ID) {
    chatReports(page: $page, status: $status, reporterId: $reporterId, roomId: $roomId) {
      total items { ...ChatReportFields }
    }
  }
  ${CHAT_REPORT_FIELDS}
`;
export const GET_CHAT_REPORT = gql`
  query ChatReport($id: ID!) { chatReport(id: $id) { ...ChatReportFields } }
  ${CHAT_REPORT_FIELDS}
`;
export const GET_CHAT_REPORT_MESSAGES = gql`
  query ChatReportMessages($id: ID!, $page: Int) {
    chatReportMessages(id: $id, page: $page) {
      total items { _id senderId content imgUrl videoUrl createdAt }
    }
  }
`;
export const REVIEW_CHAT_REPORT = gql`
  mutation ReviewChatReport($id: ID!, $status: String!, $note: String!) {
    reviewChatReport(id: $id, status: $status, note: $note) {
      _id status reviewedAt reviewedBy reviewNote
    }
  }
`;
